import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [{
            path: '',
            redirect: 'login'
        },
        {
            path: '/login',
            name: 'Login',
            component: () =>
                import ('@/views/Onboarding/login')
        },
        {
            path: '/onboarding',
            name: 'Onboarding Walkthrough',
            component: () =>
                import ('@/views/Onboarding/onboarding')
        },
        {
            path: '/otp',
            name: 'OTP',
            component: () =>
                import ('@/views/Onboarding/otp')
        }, {
            path: '/change-password',
            name: 'Set New Password',
            component: () =>
                import ('@/views/Onboarding/change-password')
        }, {
            path: '/logout',
            name: 'Logout',
            component: () =>
                import ('@/views/Onboarding/logout')
        },
        // {
        //     path: '/register',
        //     name: 'Register',
        //     component: () =>
        //         import ('@/views/Onboarding/register')

        // },
        {
            path: '/terms&conditions',
            name: 'Terms And Conditions',
            component: () =>
                import ('@/views/Onboarding/terms-conditions')

        },
        {
            path: '/declaration',
            name: 'Declaration',
            component: () =>
                import ('@/views/Onboarding/declaration')
        },
        {
            path: '/reset-password',
            name: 'Reset Password',
            component: () =>
                import ('@/views/Onboarding/reset_password')
        },
        {
            path: '/reset-password/:token',
            name: 'Reset Password',
            component: () =>
                import ('@/views/Onboarding/reset_password')
        },
        {
            path: '/account-active/:token',
            name: 'Verify Email',
            component: () =>
                import ('@/views/Onboarding/verify-email')
        },
        {
            path: '/complete-profile/:token',
            name: 'Set Password',
            component: () =>
                import ('@/views/Onboarding/terms-conditions-policies')
        },
        {   
            path : '/unauthorized',
            name:'Unauthorized',
            component: () =>
                import ('@/views/Error/unauthorized')

        },
        {
            path: '/download/certificate/:id',
            name: 'Certificate View',
            component: () =>
                import ('@/views/Certificate/view_global')
        },
        
        {
            path: '/demo/view-blockchain-doc/:uuid',
            name: 'View Blockchain Doc',
            component: () =>
                import ('@/views/Demo/view-blockchain-doc')
        },
        {
            path: '/certificate/validate/:uuid',
            name: 'Certificate Validate',
            component: () =>
                import ('@/views/Certificate/validate')
        },
        {
            path: '/manage-template/:id/preview',
            name: 'View Template',
            component: () =>
                import ('@/views/Template/preview')
        },
        {
            path: '/download/certificate/error/:uni',
            name: 'Certificate View',
            component: () =>
                import ('@/views/view_error')
        },
        {
            path: '/',
            component: () =>
                import ('@/views/main'),
            meta: {
                requiresAuth: true
            },
            children: [{
                    path: '/dashboard',
                    name: 'Dashboard',
                    component: () =>
                        import ('@/views/Dashboard/company-home')
                },
                {
                    path: '/home',
                    name: 'Dashboard',
                    component: () =>
                        import ('@/views/Dashboard/home_column_layout_only')
                },
                {
                    path: '/my-profile',
                    name: 'My Profile',
                    component: () =>
                        import ('@/views/Onboarding/my-profile')
                },
                {
                    path: '/banks',
                    name: 'Setup Bank',
                    component: () =>
                        import ('@/views/Setting/setup-bank')
                }, {
                    path: '/fee-types',
                    name: 'Setup Fee Type',
                    component: () =>
                        import ('@/views/Setting/fee-type')
                }, {
                    path: '/templates',
                    name: 'Setup Message Template',
                    component: () =>
                        import ('@/views/Setting/message-template')
                },
                {
                    path: '/edit-template/:id/:viewType',
                    name: 'Edit Message Template',
                    component: () =>
                        import ('@/views/Setting/edit-template')
                }, {
                    path: '/country',
                    name: 'Manage Locality',
                    component: () =>
                        import ('@/views/Setting/country')
                }, {
                    path: '/state',
                    name: 'Manage Locality',
                    component: () =>
                        import ('@/views/Setting/state')
                }, {
                    path: '/city',
                    name: 'Manage Locality',
                    component: () =>
                        import ('@/views/Setting/city')
                }, {
                    path: '/misc-configuration',
                    name: 'Miscellaneous Configuration',
                    component: () =>
                        import ('@/views/Setting/miscellaneous-configuration')
                }, {
                    path: '/password-policies',
                    name: 'Password Policy',
                    component: () =>
                        import ('@/views/Setting/password-policy')
                }, {
                    path: '/roles',
                    name: 'Manage Roles',
                    component: () =>
                        import ('@/views/Setting/role')
                }, {
                    path: '/add-role',
                    name: 'Add Role',
                    component: () =>
                        import ('@/views/Setting/add-role')
                }, {
                    path: '/edit-role/:id/:type/:viewType',
                    name: 'Edit Role',
                    component: () =>
                        import ('@/views/Setting/add-role')
                },
                {
                    path: '/view-role/:id/:type/:viewType',
                    name: 'View Role',
                    component: () =>
                        import ('@/views/Setting/add-role')
                },
                {
                    path: '/companies',
                    name: 'Manage Organization',
                    component: () =>
                        import ('@/views/UserManagement/manage-company')
                }, {
                    path: '/add-manage-company',
                    name: 'Add Manage Organization',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-company')
                }, {
                    path: '/edit-manage-company/:id/:viewType',
                    name: 'Edit Manage Company',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-company')
                },
                {
                    path: '/admin',
                    name: 'Manage System Admin',
                    component: () =>
                        import ('@/views/UserManagement/manage-system-user')
                }, {
                    path: '/add-manage-system-user',
                    name: 'Add System Admin User',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-system-user')
                }, {
                    path: '/edit-manage-system-user/:id/:viewType',
                    name: 'Edit Manage SystemUser',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-system-user')
                }, 
                {
                    path: '/employers',
                    name: 'Manage Organization Admin',
                    component: () =>
                        import ('@/views/UserManagement/manage-employer-admin')
                }, {
                    path: '/add-organization-user',
                    name: 'Add Organization User',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-employer-admin')
                }, {
                    path: '/edit-employer-admin/:id/:viewType',
                    name: 'Edit Employee Admin',
                    component: () =>
                        import ('@/views/UserManagement/add-manage-employer-admin')
                },
                // {
                //     path: '/news-announcements',
                //     name: 'News & Announcement',
                //     component: () =>
                //         import ('@/views/NewsAndAnnouncement/news-and-announcement')
                // },
                {
                    path: '/privacy-policy',
                    name: 'Privacy Policy',
                    component: () =>
                        import ('@/views/Support/privacy')
                },
                {
                    path: '/terms-conditions',
                    name: 'Terms And Conditions',
                    component: () =>
                        import ('@/views/Support/term')
                },
                // {
                //     path: '/announcements',
                //     name: 'News & Announcement',
                //     component: () =>
                //         import ('@/views/NewsAndAnnouncement/view-news-and-announcement')
                // },
                // {
                //     path: '/news-announcements-detail/:id',
                //     name: 'News & Announcement',
                //     component: () =>
                //         import ('@/views/NewsAndAnnouncement/view-news-and-announcement-details')
                // },
                // {
                //     path: '/add/news-announcement',
                //     name: 'News & Announcement',
                //     component: () =>
                //         import ('@/views/NewsAndAnnouncement/news-and-updates')
                // },
                // {
                //     path: '/edit/news-announcement/:id',
                //     name: 'Edit News & Announcement',
                //     component: () =>
                //         import ('@/views/NewsAndAnnouncement/news-and-updates')
                // },
                // {
                //     path: '/view/news-announcement/:id',
                //     name: 'View News & Announcement',
                //     component: () =>
                //         import ('@/views/NewsAndAnnouncement/view-news-announcement-employer')
                // },
                {
                    path: 'static/terms-conditions',
                    name: 'Term And Condition',
                    component: () =>
                        import ('@/views/Support/terms-and-condition')
                }, {
                    path: 'static/privacy-policy',
                    name: 'Privacy Policy',
                    component: () =>
                        import ('@/views/Support/privacy-policy')
                }, {
                    path: '/static/faq',
                    name: 'FAQ\'s',
                    component: () =>
                        import ('@/views/Support/faq')
                },
                {
                    path: '/faq',
                    name: 'Faq',
                    component: () =>
                        import ('@/views/Support/view-faq')
                },
                {
                    path: '/add-faq',
                    name: 'Add FAQ',
                    component: () =>
                        import ('@/views/Support/add-faq')
                },
                {
                    path: '/edit-faq/:id/:viewType',
                    name: 'Edit FAQ',
                    component: () =>
                        import ('@/views/Support/add-faq')
                },
                {
                    path: '/about',
                    name: 'About Us',
                    component: () =>
                        import ('@/views/Support/about-us')
                },
                {
                    path: '/about-us',
                    name: 'About Us Employee',
                    component: () =>
                        import ('@/views/Support/about-us-employee')
                },
                {
                    path: '/static/feedback',
                    name: 'Feedback',
                    component: () =>
                        import ('@/views/Support/feedback')
                },
                {
                    path: '/feedback',
                    name: 'Feedback',
                    component: () =>
                        import ('@/views/Support/add-feedback')
                },
                {
                    path: '/view-notifications',
                    name: 'Notification List',
                    component: () =>
                        import ('@/views/Support/notifications')
                },
                {
                    path: '/view-notifications/:id',
                    name: 'Notification',
                    component: () =>
                        import ('@/views/Support/notification-details')
                },
                {
                    path: '/static/disclaimer',
                    name: 'Disclaimer',
                    component: () =>
                        import ('@/views/Support/disclaimer')
                },
                {
                    path: '/disclaimer',
                    name: 'Disclaimer',
                    component: () =>
                        import ('@/views/Support/view-disclaimer')
                }, {
                    path: '/reports',
                    name: 'Reports',
                    component: () =>
                        import ('@/views/Reports/reports')
                },
                {
                    path: '/refer-friend',
                    name: 'Refer A friend',
                    component: () =>
                        import ('@/views/Reports/refer-a-friend')
                },
                {
                    path: '/users-listing',
                    name: 'User Report',
                    component: () =>
                        import ('@/views/Reports/users-listing')
                },
                {
                    path: '/sample-report',
                    name: 'Sample Report',
                    component: () =>
                        import ('@/views/Reports/SampleReport')
                },
                {
                    path: '/organization-listing',
                    name: 'Organization Report',
                    component: () =>
                        import ('@/views/Reports/organization-listing')
                },
                {
                    path: '/certificate-listing',
                    name: 'Certificate Report',
                    component: () =>
                        import ('@/views/Reports/certificate-listing')
                },
                {
                    path: '/certificate-generation-listing',
                    name: 'Certificate Generation',
                    component: () =>
                        import ('@/views/Reports/certificate-generation')
                },
                {
                    path: '/e-cert-generation-listing',
                    name: 'E-Cert Generation',
                    component: () =>
                        import ('@/views/Reports/e-cert-generation')
                },
                {
                    path: '/audit_trail',
                    name: 'Audit Trail',
                    component: () =>
                        import ('@/views/Reports/audit-trail')
                },
                {
                    path: '/access-denied',
                    name: 'Access Denied',
                    component: () =>
                        import ('@/views/Error/access-denied')
                },
                {
                    path: '/certificate',
                    name: 'Manage Certificate',
                    component: () =>
                        import ('@/views/Certificate/list')
                },
                {
                    path: '/view-certificate/:id/:viewType',
                    name: 'Certificate View',
                    component: () =>
                        import ('@/views/Certificate/view')
                },
                {
                    path: '/certificate/scanned-history/:id',
                    name: 'Certificate View',
                    component: () =>
                        import ('@/views/Certificate/scanned-history')
                },
                {
                    path: '/manage-template',
                    name: 'Manage Template',
                    component: () =>
                        import ('@/views/Template/manage-template')
                },
                {
                    path: '/manage-template/:id/view',
                    name: 'View Template',
                    component: () =>
                        import ('@/views/Template/view')
                },
                {
                    path: '/manage-activity-log',
                    name: 'Manage Activity Log',
                    component: () =>
                        import ('@/views/ActivityLog/manage-activity-log')
                },
                {
                    path: '/interface-logs',
                    name: 'Interface Logs',
                    component: () =>
                        import ('@/views/Reports/interface-log')
                },
                // DEMO
                {
                    path: '/dEm0bQC',
                    name: 'Demo',
                    component: () =>
                        import ('@/views/Demo/demo')
                },
                {
                    path: '/demo/edit/:uuid',
                    name: 'Demo Edit',
                    component: () =>
                        import ('@/views/Demo/demo-edit')
                },
                {
                    path: '/demo/view/:uuid',
                    name: 'View Doc',
                    component: () =>
                        import ('@/views/Demo/view-doc')
                },
              
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    document.title = `${process.env.APP_TITLE} :: ${to.name}`
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!localStorage.getItem('token') || localStorage.getItem('token') == null || localStorage.getItem('isVerify') == null) {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        if (to.path === '/login') {
            if (localStorage.getItem('token') != null && localStorage.getItem('isVerify') != null) {
                if (process.env.IS_ADMIN) {
                    next({
                        path: '/dashboard',
                        params: { nextUrl: to.fullPath }
                    })
                } else {
                    next({
                        path: '/dashboard',
                        params: { nextUrl: to.fullPath }
                    });
                }
            } else {
                next()
            }
        } else {
            next()
        }
    }
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js